import React, { FC } from 'react';
import classNames from 'classnames';
import { SearchCard, PlayerCard } from '.';
import {
  gameSearchStyles,
  playerContainerStyles,
  enemyContainerStyles,
  vsImageStyles,
  containerStyles,
} from './styles.css';
import { PlayerState } from '~/src/components/Game/types';

type GameSearchProps = {
  player?: PlayerState;
  enemy?: PlayerState;
};

const GameSearch: FC<GameSearchProps> = ({ player, enemy }) => (
  <div className={gameSearchStyles}>
    <div className={classNames(containerStyles, enemyContainerStyles)}>
      {enemy?.id ? <PlayerCard {...enemy} /> : <SearchCard />}
    </div>
    <div className={classNames(containerStyles, playerContainerStyles)}>
      <PlayerCard {...player} />
    </div>
    <img className={vsImageStyles} src="assets/images/vs.png" />
  </div>
);

export default GameSearch;
